function getFileUrl(endpoint, params){
    var url = window.axios.defaults.baseURL + endpoint + '?';
    Object.keys(params).forEach((param) => {
        if (params[param] !== null && params[param] !== undefined){
            url += `${param}=${params[param]}&`
        }
    })
    url = url.slice(0, url.length - 1);
    return url;
}

export default {
    namespaced: true,

    actions: {
        RegularAccountStatement(vuexContext, { 
            type,
            financialFileId,
            account_id,
            start_date,
            end_date,
            keywords,
            Includes_previous_balance,
            userId,
            brief,
            fromLatestMatchingDate
        }){
            /*
             - int financialFileId
             - int account_id
             - DateTime start_date
             - DateTime end_date
             - String keywords
             - Includes_previous_balance
             - String userId
             - bool brief   //default: FALSE //لطلب تقرير مختصر 
             - bool fromLatestMatchingDate  //default: FALSE //للطباعة من آخر تاريخ مطابقة
            */
            const endpoint = 'StatementReport/Regular';
            let reportType = null;
            if (type.toLocaleLowerCase() === 'excel') {
                reportType = 1;
            }
            else if (type.toLocaleLowerCase() === 'pdf') {
                reportType = 0;
            }

            window.open(
                getFileUrl(endpoint, {
                    reportType,
                    financialFileId,
                    account_id,
                    start_date,
                    end_date,
                    keywords,
                    Includes_previous_balance,
                    userId,
                    brief: brief ? brief : false,
                    fromLatestMatchingDate: fromLatestMatchingDate ? fromLatestMatchingDate : false,
                })
            , '_self')
        },

        CustomAccountStatement(vuexContext, { 
            type,
            financialFileId,
            customStatementId,
            userId,
            showNonZeroAccountsOnly
        }){
            /*
             -	int financialFileId
             -	int customStatementId
             -	string userId
             -	bool showNonZeroAccountsOnly
            */
            const endpoint = 'StatementReport/Custom';
            let reportType = null;
            if (type.toLocaleLowerCase() === 'excel') {
                reportType = 1;
            }
            else if (type.toLocaleLowerCase() === 'pdf') {
                reportType = 0;
            }

            window.open(
                getFileUrl(endpoint, {
                    reportType,
                    financialFileId,
                    customStatementId,
                    userId,
                    showNonZeroAccountsOnly
                })
            , '_self')
        },

        JournalTableReport(vuexContext, { 
            type,
            financialFileId,
            userId,
            ToDate,
            FromDate,
            keywords,
            onlyDebitEntries
        }){
            /*
             -	int financialFileId
             -	string userId
             -	DateTime? ToDate
             -	DateTime? FromDate
             -	string keywords
             -	bool onlyDebitEntries
            */
            const endpoint = 'StatementReport/DailyTableReport';
            let reportType = null;
            if (type.toLocaleLowerCase() === 'excel') {
                reportType = 1;
            }
            else if (type.toLocaleLowerCase() === 'pdf') {
                reportType = 0;
            }

            window.open(
                getFileUrl(endpoint, {
                    financialFileId,
                    reportType,
                    userId,
                    ToDate,
                    FromDate,
                    keywords,
                    onlyDebitEntries
                })
            , '_self')
            
        },

        InventoryReport(vuexContext, { 
            type,
            financialFileId,
            userId,
            warehouseId,
            materialId,
            withPrimaryMaterials,
            whereMaterialsHaveBalances,
            materialDeliveryStatus
        }){
            /*
             -	int financialFileId
             -	string userId
             -	int? warehouseId
             -	int? materialId
             -	bool withPrimaryMaterials
             -	bool whereMaterialsHaveBalances
            */
            const endpoint = 'StatementReport/InventoryReport';
            let reportType = null;
            if (type.toLocaleLowerCase() === 'excel') {
                reportType = 1;
            }
            else if (type.toLocaleLowerCase() === 'pdf') {
                reportType = 0;
            }

            window.open(
                getFileUrl(endpoint, {
                    reportType,
                    financialFileId,
                    userId,
                    warehouseId,
                    materialId,
                    withPrimaryMaterials,
                    whereMaterialsHaveBalances,
                    materialDeliveryStatus
                })
            , '_self')
        },

        TrailBalanceReport(vuexContext, { 
            type,
            financialFileId,
            accountId,
            userId,
            showParentAccounts,
            showNonZeroAccountsOnly,
            fromAccountingNo,
            toAccountingNo,
            brief
        }){
            /*
             -	int financialFileId
             -	int? accountId
             -	string userId
             -	bool showParentAccounts
             -	bool showNonZeroAccountsOnly
             -	string fromAccountingNo
             -	string toAccountingNo
            */
            const endpoint = 'StatementReport/TrialBalance';
            let reportType = null;
            if (type.toLocaleLowerCase() === 'excel') {
                reportType = 1;
            }
            else if (type.toLocaleLowerCase() === 'pdf') {
                reportType = 0;
            }

            window.open(
                getFileUrl(endpoint, {
                    reportType,
                    financialFileId,
                    accountId,
                    userId,
                    showParentAccounts,
                    showNonZeroAccountsOnly,
                    fromAccountingNo,
                    toAccountingNo,
                    brief: brief ? brief : false
                })
            , '_self')
        },

        FinalAccountsReport(vuexContext, { 
            type,
            financialFileId,
            userId,
        }){
            /*
             -	int financialFileId
             -	string userId
            */
            const endpoint = 'StatementReport/FinalAccountsResultReport';
            let reportType = null;
            if (type.toLocaleLowerCase() === 'excel') {
                reportType = 1;
            }
            else if (type.toLocaleLowerCase() === 'pdf') {
                reportType = 0;
            }

            window.open(
                getFileUrl(endpoint, {
                    reportType,
                    financialFileId,
                    userId
                })
            , '_self')
        },

        MaterialsTreeReport(vuexContext, { 
            type,
            financialFileId,
            userId,
            warehouseId
        }){
            /*
             -	int financialFileId
             -	string userId
             -	int  warehouseId
            */
            const endpoint = 'StatementReport/MaterialsTree';
            let reportType = null;
            if (type.toLocaleLowerCase() === 'excel') {
                reportType = 1;
            }
            else if (type.toLocaleLowerCase() === 'pdf') {
                reportType = 0;
            }

            window.open(
                getFileUrl(endpoint, {
                    reportType,
                    financialFileId,
                    userId,
                    warehouseId
                })
            , '_self')
        },

        AccountsTreeReport(vuexContext, { 
            type,
            financialFileId,
            userId
        }){
            /*
             -	int financialFileId
             -	string userId
            */
            let endpoint = 'StatementReport/AccountsTree';
            let reportType = null;
            if (type.toLocaleLowerCase() === 'excel') {
                reportType = 1;
            }
            else if (type.toLocaleLowerCase() === 'pdf') {
                reportType = 0;
            }

            window.open(
                getFileUrl(endpoint, {
                    reportType,
                    financialFileId,
                    userId
                })
            , '_self')
        },

        MaterialStatementReport(vuexContext, {
            type,
            financialFileId,
            userId,
            materialId,
            FromDate,
            ToDate
        }){
            /*
             -	int financialFileId
             -	string userId
             -	int materialId
             -	DateTime? FromDate
             -	DateTime? ToDate
            */

            const endpoint = 'StatementReport/MaterialStatementReport';
            let reportType = null;
            if (type.toLocaleLowerCase() === 'excel') {
               reportType = 1;
            }
            else if (type.toLocaleLowerCase() === 'pdf') {
               reportType = 0;
            }
            window.open(
                getFileUrl(endpoint, {
                    reportType,
                    financialFileId,
                    userId,
                    materialId,
                    FromDate,
                    ToDate
                })
            , '_self')
        },
        salesStatementReport(vuexContext, {
            type,
            financialFileId,
            userId,
            materialId,
            accountId,
            fromDate,
            toDate,
        }){
            const endpoint = 'StatementReport/SalesStatementReport';
            let reportType = null;
            if (type.toLocaleLowerCase() === 'excel') {
               reportType = 1;
            }
            else if (type.toLocaleLowerCase() === 'pdf') {
               reportType = 0;
            }
            
            window.open(
                getFileUrl(endpoint, {
                    reportType,
                    financialFileId,
                    userId,
                    materialId,
                    accountId,
                    fromDate,
                    toDate,
                    sortType: 2,
                    transactionType: 2,
                    justInvoiceEntries: true,
                })
            , '_self')
        },
        advanceStatement(vuexContext, {
            type,
            financialFileId,
            userId,
            account_id,
            keywords,
            includes_previous_balance,
            fromLatestMatchingDate,
            start_date,
            end_date
        }){
            const endpoint = 'StatementReport/LedgerStatement';
            let reportType = null;
            if (type.toLocaleLowerCase() === 'excel') {
               reportType = 1;
            }
            else if (type.toLocaleLowerCase() === 'pdf') {
               reportType = 0;
            }
            
            window.open(
                getFileUrl(endpoint, {
                    reportType,
                    financialFileId,
                    userId,
                    keywords,
                    includes_previous_balance,
                    account_id,
                    fromLatestMatchingDate: fromLatestMatchingDate ? fromLatestMatchingDate : false,
                    start_date,
                    end_date
                })
            , '_self')
        },

        invoice(vuexContext, {
            type,
            financialFileId,
            userId,
            invoiceType,
            invoiceId,
        }){
            const endpoint = 'StatementReport/InvoiceReport';
            let reportType = null;
            if (type.toLocaleLowerCase() === 'excel') {
               reportType = 1;
            }
            else if (type.toLocaleLowerCase() === 'pdf') {
               reportType = 0;
            }
            
            window.open(
                getFileUrl(endpoint, {
                    reportType,
                    financialFileId,
                    userId,
                    invoiceType,
                    invoiceId
                })
            , '_self')
        },
    }
}

/*
    Excel                               PDF
    1.	Regular Account Statement       9.	Regular Account Statement 
    2.	Custom Account Statement        10.	Custom Account Statement 
    3.	Journal Table Report            11.	Journal Table Report
    4.	Inventory Report                12.	Inventory Report
    5.	Trial Balance Report            13.	Trial Balance Report
    6.	Final Accounts Report           14.	Final Accounts Report
    7.	Materials Tree Report           16.	Materials Tree Report
    8.	Accounts Tree Report            17.	Accounts Tree Report
    -                                   15.	Material Statement Report
*/